export default __webpack_public_path__ + "static/media/BalioaLogoWhite.01488aee.png";